import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../Backend/Backend";
import { useSelector } from "react-redux";

const fmt = require("indian-number-format");
const backend = await new Backend().init();

export default function HeaderAccount({ isDollar }) {
  const total = useSelector((state) => Number(state.total || 0));
  const currency = isDollar === 1 ? "$" : "";

  const [loading, setLoading] = useState(true);

  const [credit, setCredit] = useState(0);
  const [depositCurrent, setDepositCurrent] = useState(0);
  const [profitLoss, setProfitLoss] = useState(0);
  const [equity, setEquity] = useState(0);
  const [margin, setMargin] = useState(0);
  const [marginFree, setMarginFree] = useState(0);

  /** ✅ Load Profit / Loss */
  const loadProfitLoss = useCallback(async () => {
    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
      };

      const res = await backend.profit_loss(data);

      if (res?.error === "False") {
        setCredit(+res.credit || 0);
        setDepositCurrent(+res.deposit_current || 0);
        setProfitLoss(+res.profit_loss || 0);
        setEquity(+res.equity || 0);
        setMargin(+res.margin || 0);
        setMarginFree(+res.marginfree || 0);
      } else {
        if (res?.logout === 1) {
          window.LogOut?.();
        } else {
          toast.error(res?.message || "Failed to load P/L data");
        }
      }
    } catch (err) {
      console.error("HeaderAccount Error:", err);
      toast.error("Error loading account data");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProfitLoss();
  }, [loadProfitLoss]);

  /** ✅ Derived values (ZERO when loading) */
  const netEquity = loading ? 0 : Number(equity) + Number(total);
  const marginPercent =
    loading || netEquity <= 0
      ? "0.00"
      : ((marginFree / netEquity) * 100).toFixed(2);

  return (
    <div className="px-5 py-3 text-[14px] space-y-1 text-[var(--text)]">
      <Row label="Booked" value={loading ? 0 : profitLoss} currency={currency} />
      <Row label="Equity" value={loading ? 0 : netEquity} currency={currency} />
      <Row label="Margin" value={loading ? 0 : margin} currency={currency} />
      <Row
        label="Free Margin"
        value={loading ? 0 : marginFree}
        currency={currency}
      />

      {/* ✅ Margin Level */}
      <div className="flex justify-between">
        <span>Margin Level:</span>
        <span className="font-semibold">
          {loading ? "0%" : `${marginPercent}%`}
        </span>
      </div>
    </div>
  );
}

/** 🔹 Reusable Row */
function Row({ label, value, currency }) {
  const isPositive = value >= 0;

  return (
    <div className="flex justify-between">
      <span>{label}:</span>
      <span
        className={`font-semibold ${
          isPositive ? "text-[var(--buymeta)]" : "text-[var(--sellmeta)]"
        }`}
      >
        {fmt.format(Number(value).toFixed(2))} {currency}
      </span>
    </div>
  );
}
